// tslint:disable
/**
 * まなびスタンプ 学習者API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * コースID
 * @export
 * @enum {string}
 */
export enum CourseId {
    calc = 'calc',
    japanese = 'japanese',
    number = 'number',
    word = 'word'
}

/**
 * 
 * @export
 * @interface CourseProgress
 */
export interface CourseProgress {
    /**
     * 単元No
     * @type {number}
     * @memberof CourseProgress
     */
    sectionNo: number;
    /**
     * 正答ユニットNo配列
     * @type {Array<number>}
     * @memberof CourseProgress
     */
    unitNos: Array<number>;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof ErrorResponse
     */
    status: HttpStatusCode;
    /**
     * APIパス
     * @type {string}
     * @memberof ErrorResponse
     */
    path: string;
    /**
     * 発生日時
     * @type {string}
     * @memberof ErrorResponse
     */
    timestamp: string;
    /**
     * エラー概要
     * @type {string}
     * @memberof ErrorResponse
     */
    error: string;
    /**
     * エラー概要
     * @type {string}
     * @memberof ErrorResponse
     */
    message: string;
    /**
     * エラー詳細
     * @type {string}
     * @memberof ErrorResponse
     */
    trace?: string;
    /**
     * 例外クラス
     * @type {string}
     * @memberof ErrorResponse
     */
    exception?: string;
    /**
     * 入力エラー内容(status=400 の場合のみ)
     * @type {Array<FieldErrorResponse>}
     * @memberof ErrorResponse
     */
    errors?: Array<FieldErrorResponse>;
}
/**
 * 入力フィールドエラー
 * @export
 * @interface FieldErrorResponse
 */
export interface FieldErrorResponse {
    /**
     * 入力フィールド
     * @type {string}
     * @memberof FieldErrorResponse
     */
    field: string;
    /**
     * 入力オブジェクト
     * @type {string}
     * @memberof FieldErrorResponse
     */
    objectName: string;
    /**
     * エラー内容
     * @type {string}
     * @memberof FieldErrorResponse
     */
    defaultMessage: string;
}
/**
 * 
 * @export
 * @interface GoogleLoginRequest
 */
export interface GoogleLoginRequest {
    /**
     * 教室ID
     * @type {string}
     * @memberof GoogleLoginRequest
     */
    roomId: string;
    /**
     * Google認証IDトークン
     * @type {string}
     * @memberof GoogleLoginRequest
     */
    credential: string;
}
/**
 * HTTPステータスコード
 * @export
 * @enum {string}
 */
export enum HttpStatusCode {
    badRequest = 400,
    unauthorized = 401,
    forbidden = 403,
    notFound = 404,
    requestTimeout = 408,
    internalServerError = 500
}

/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 教室ID
     * @type {string}
     * @memberof LoginRequest
     */
    roomId: string;
    /**
     * ログインキー
     * @type {string}
     * @memberof LoginRequest
     */
    loginKey: string;
}
/**
 * 結果No(0：未、1：〇、2：✖)
 * @export
 * @enum {string}
 */
export enum ResultNo {
    yet = 0,
    success = 1,
    fail = 2
}

/**
 * 
 * @export
 * @interface RoomResponse
 */
export interface RoomResponse {
    /**
     * 教室名
     * @type {string}
     * @memberof RoomResponse
     */
    roomName?: string;
    /**
     * 教室名カナ
     * @type {string}
     * @memberof RoomResponse
     */
    roomNameKana?: string;
    /**
     * 
     * @type {RoomType}
     * @memberof RoomResponse
     */
    roomType: RoomType;
}
/**
 * 教室種別(0：一般、1：まなびポケット、2：GoogleSSO、3：ベスプラ)
 * @export
 * @enum {string}
 */
export enum RoomType {
    normal = 0,
    manabi = 1,
    google = 2,
    bespra = 3
}

/**
 * 
 * @export
 * @interface StudyRequest
 */
export interface StudyRequest {
    /**
     * 
     * @type {CourseId}
     * @memberof StudyRequest
     */
    courseId: CourseId;
    /**
     * 単元No
     * @type {number}
     * @memberof StudyRequest
     */
    sectionNo: number;
    /**
     * ユニットNo
     * @type {number}
     * @memberof StudyRequest
     */
    unitNo: number;
    /**
     * ステージ名
     * @type {string}
     * @memberof StudyRequest
     */
    stageName: string;
    /**
     * 
     * @type {ResultNo}
     * @memberof StudyRequest
     */
    resultNo: ResultNo;
    /**
     * 学習メモ
     * @type {string}
     * @memberof StudyRequest
     */
    studyMemo: string;
    /**
     * 学習開始日時
     * @type {string}
     * @memberof StudyRequest
     */
    studyStartDt: string;
    /**
     * 学習時間
     * @type {number}
     * @memberof StudyRequest
     */
    studySec: number;
    /**
     * 
     * @type {CourseProgress}
     * @memberof StudyRequest
     */
    courseProgress?: CourseProgress;
}
/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * ニックネーム
     * @type {string}
     * @memberof UserResponse
     */
    nickname?: string;
    /**
     * 学習者メモ
     * @type {string}
     * @memberof UserResponse
     */
    userMemo?: string;
    /**
     * 
     * @type {UserType}
     * @memberof UserResponse
     */
    userType: UserType;
    /**
     * ログインキー
     * @type {string}
     * @memberof UserResponse
     */
    loginKey: string;
    /**
     * 学習者スタンプ
     * @type {string}
     * @memberof UserResponse
     */
    userStamp?: string;
}
/**
 * 
 * @export
 * @interface UserStampRequest
 */
export interface UserStampRequest {
    /**
     * 学習者スタンプ
     * @type {string}
     * @memberof UserStampRequest
     */
    userStamp: string;
}
/**
 * ユーザー種別(0：通常、1：体験、2：こんぷ、3：コンプまえ、4：正解　※「1：体験」はDBに登録しないユーザー)
 * @export
 * @enum {string}
 */
export enum UserType {
    normal = 0,
    guest = 1,
    complete = 2,
    oneUnitLeft = 3,
    correct = 4
}


/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します（※体験ユーザーは使用しない）
         * @summary Googleログイン
         * @param {GoogleLoginRequest} googleLoginRequest 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(googleLoginRequest: GoogleLoginRequest, options: any = {}): RequestArgs {
            // verify required parameter 'googleLoginRequest' is not null or undefined
            if (googleLoginRequest === null || googleLoginRequest === undefined) {
                throw new RequiredError('googleLoginRequest','Required parameter googleLoginRequest was null or undefined when calling googleLogin.');
            }
            const localVarPath = `/login/google`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof googleLoginRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(googleLoginRequest !== undefined ? googleLoginRequest : {}) : (googleLoginRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します（※体験ユーザーは使用しない）
         * @summary ログイン
         * @param {LoginRequest} loginRequest 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest: LoginRequest, options: any = {}): RequestArgs {
            // verify required parameter 'loginRequest' is not null or undefined
            if (loginRequest === null || loginRequest === undefined) {
                throw new RequiredError('loginRequest','Required parameter loginRequest was null or undefined when calling login.');
            }
            const localVarPath = `/login`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loginRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loginRequest !== undefined ? loginRequest : {}) : (loginRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します（※体験ユーザーは使用しない）
         * @summary Googleログイン
         * @param {GoogleLoginRequest} googleLoginRequest 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(googleLoginRequest: GoogleLoginRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LoginApiAxiosParamCreator(configuration).googleLogin(googleLoginRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します（※体験ユーザーは使用しない）
         * @summary ログイン
         * @param {LoginRequest} loginRequest 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest: LoginRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LoginApiAxiosParamCreator(configuration).login(loginRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します（※体験ユーザーは使用しない）
         * @summary Googleログイン
         * @param {GoogleLoginRequest} googleLoginRequest 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(googleLoginRequest: GoogleLoginRequest, options?: any): AxiosPromise<void> {
            return LoginApiFp(configuration).googleLogin(googleLoginRequest, options)(axios, basePath);
        },
        /**
         * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します（※体験ユーザーは使用しない）
         * @summary ログイン
         * @param {LoginRequest} loginRequest 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest: LoginRequest, options?: any): AxiosPromise<void> {
            return LoginApiFp(configuration).login(loginRequest, options)(axios, basePath);
        },
    };
};

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
    /**
     * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します（※体験ユーザーは使用しない）
     * @summary Googleログイン
     * @param {GoogleLoginRequest} googleLoginRequest 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public googleLogin(googleLoginRequest: GoogleLoginRequest, options?: any) {
        return LoginApiFp(this.configuration).googleLogin(googleLoginRequest, options)(this.axios, this.basePath);
    }

    /**
     * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します（※体験ユーザーは使用しない）
     * @summary ログイン
     * @param {LoginRequest} loginRequest 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public login(loginRequest: LoginRequest, options?: any) {
        return LoginApiFp(this.configuration).login(loginRequest, options)(this.axios, this.basePath);
    }

}


/**
 * RoomApi - axios parameter creator
 * @export
 */
export const RoomApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 教室IDに紐づく教室を取得します
         * @summary 教室
         * @param {string} roomId 教室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showRoom(roomId: string, options: any = {}): RequestArgs {
            // verify required parameter 'roomId' is not null or undefined
            if (roomId === null || roomId === undefined) {
                throw new RequiredError('roomId','Required parameter roomId was null or undefined when calling showRoom.');
            }
            const localVarPath = `/room/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoomApi - functional programming interface
 * @export
 */
export const RoomApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 教室IDに紐づく教室を取得します
         * @summary 教室
         * @param {string} roomId 教室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showRoom(roomId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse> {
            const localVarAxiosArgs = RoomApiAxiosParamCreator(configuration).showRoom(roomId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RoomApi - factory interface
 * @export
 */
export const RoomApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 教室IDに紐づく教室を取得します
         * @summary 教室
         * @param {string} roomId 教室ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showRoom(roomId: string, options?: any): AxiosPromise<RoomResponse> {
            return RoomApiFp(configuration).showRoom(roomId, options)(axios, basePath);
        },
    };
};

/**
 * RoomApi - object-oriented interface
 * @export
 * @class RoomApi
 * @extends {BaseAPI}
 */
export class RoomApi extends BaseAPI {
    /**
     * 教室IDに紐づく教室を取得します
     * @summary 教室
     * @param {string} roomId 教室ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public showRoom(roomId: string, options?: any) {
        return RoomApiFp(this.configuration).showRoom(roomId, options)(this.axios, this.basePath);
    }

}


/**
 * StudyApi - axios parameter creator
 * @export
 */
export const StudyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 学習結果を登録します
         * @summary 学習結果登録
         * @param {StudyRequest} studyRequest 学習結果情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        study(studyRequest: StudyRequest, options: any = {}): RequestArgs {
            // verify required parameter 'studyRequest' is not null or undefined
            if (studyRequest === null || studyRequest === undefined) {
                throw new RequiredError('studyRequest','Required parameter studyRequest was null or undefined when calling study.');
            }
            const localVarPath = `/study`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("msUserToken")
                    : configuration.apiKey;
                localVarHeaderParameter["msUserToken"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof studyRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(studyRequest !== undefined ? studyRequest : {}) : (studyRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StudyApi - functional programming interface
 * @export
 */
export const StudyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 学習結果を登録します
         * @summary 学習結果登録
         * @param {StudyRequest} studyRequest 学習結果情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        study(studyRequest: StudyRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = StudyApiAxiosParamCreator(configuration).study(studyRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StudyApi - factory interface
 * @export
 */
export const StudyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 学習結果を登録します
         * @summary 学習結果登録
         * @param {StudyRequest} studyRequest 学習結果情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        study(studyRequest: StudyRequest, options?: any): AxiosPromise<void> {
            return StudyApiFp(configuration).study(studyRequest, options)(axios, basePath);
        },
    };
};

/**
 * StudyApi - object-oriented interface
 * @export
 * @class StudyApi
 * @extends {BaseAPI}
 */
export class StudyApi extends BaseAPI {
    /**
     * 学習結果を登録します
     * @summary 学習結果登録
     * @param {StudyRequest} studyRequest 学習結果情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyApi
     */
    public study(studyRequest: StudyRequest, options?: any) {
        return StudyApiFp(this.configuration).study(studyRequest, options)(this.axios, this.basePath);
    }

}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証/認可トークンの学習者情報を取得します（※体験ユーザーは使用しない）
         * @summary 学習者
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showUser(options: any = {}): RequestArgs {
            const localVarPath = `/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("msUserToken")
                    : configuration.apiKey;
                localVarHeaderParameter["msUserToken"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンの学習者の学習者スタンプ情報を更新します
         * @summary 学習者スタンプ編集
         * @param {UserStampRequest} userStampRequest 学習者スタンプ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStamp(userStampRequest: UserStampRequest, options: any = {}): RequestArgs {
            // verify required parameter 'userStampRequest' is not null or undefined
            if (userStampRequest === null || userStampRequest === undefined) {
                throw new RequiredError('userStampRequest','Required parameter userStampRequest was null or undefined when calling updateUserStamp.');
            }
            const localVarPath = `/user/stamp`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("msUserToken")
                    : configuration.apiKey;
                localVarHeaderParameter["msUserToken"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userStampRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userStampRequest !== undefined ? userStampRequest : {}) : (userStampRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 認証/認可トークンの学習者情報を取得します（※体験ユーザーは使用しない）
         * @summary 学習者
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showUser(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).showUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 認証/認可トークンの学習者の学習者スタンプ情報を更新します
         * @summary 学習者スタンプ編集
         * @param {UserStampRequest} userStampRequest 学習者スタンプ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStamp(userStampRequest: UserStampRequest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).updateUserStamp(userStampRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 認証/認可トークンの学習者情報を取得します（※体験ユーザーは使用しない）
         * @summary 学習者
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showUser(options?: any): AxiosPromise<UserResponse> {
            return UserApiFp(configuration).showUser(options)(axios, basePath);
        },
        /**
         * 認証/認可トークンの学習者の学習者スタンプ情報を更新します
         * @summary 学習者スタンプ編集
         * @param {UserStampRequest} userStampRequest 学習者スタンプ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserStamp(userStampRequest: UserStampRequest, options?: any): AxiosPromise<void> {
            return UserApiFp(configuration).updateUserStamp(userStampRequest, options)(axios, basePath);
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 認証/認可トークンの学習者情報を取得します（※体験ユーザーは使用しない）
     * @summary 学習者
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public showUser(options?: any) {
        return UserApiFp(this.configuration).showUser(options)(this.axios, this.basePath);
    }

    /**
     * 認証/認可トークンの学習者の学習者スタンプ情報を更新します
     * @summary 学習者スタンプ編集
     * @param {UserStampRequest} userStampRequest 学習者スタンプ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateUserStamp(userStampRequest: UserStampRequest, options?: any) {
        return UserApiFp(this.configuration).updateUserStamp(userStampRequest, options)(this.axios, this.basePath);
    }

}


/**
 * UserProgressApi - axios parameter creator
 * @export
 */
export const UserProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証/認可トークンとコースIDに紐付くコース進捗を取得します（※体験ユーザーは使用しない）
         * @summary 学習者進度・コース進捗
         * @param {CourseId} courseId コースID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showUserProgress(courseId: CourseId, options: any = {}): RequestArgs {
            // verify required parameter 'courseId' is not null or undefined
            if (courseId === null || courseId === undefined) {
                throw new RequiredError('courseId','Required parameter courseId was null or undefined when calling showUserProgress.');
            }
            const localVarPath = `/userProgress/{courseId}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("msUserToken")
                    : configuration.apiKey;
                localVarHeaderParameter["msUserToken"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserProgressApi - functional programming interface
 * @export
 */
export const UserProgressApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 認証/認可トークンとコースIDに紐付くコース進捗を取得します（※体験ユーザーは使用しない）
         * @summary 学習者進度・コース進捗
         * @param {CourseId} courseId コースID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showUserProgress(courseId: CourseId, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CourseProgress>> {
            const localVarAxiosArgs = UserProgressApiAxiosParamCreator(configuration).showUserProgress(courseId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserProgressApi - factory interface
 * @export
 */
export const UserProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 認証/認可トークンとコースIDに紐付くコース進捗を取得します（※体験ユーザーは使用しない）
         * @summary 学習者進度・コース進捗
         * @param {CourseId} courseId コースID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showUserProgress(courseId: CourseId, options?: any): AxiosPromise<Array<CourseProgress>> {
            return UserProgressApiFp(configuration).showUserProgress(courseId, options)(axios, basePath);
        },
    };
};

/**
 * UserProgressApi - object-oriented interface
 * @export
 * @class UserProgressApi
 * @extends {BaseAPI}
 */
export class UserProgressApi extends BaseAPI {
    /**
     * 認証/認可トークンとコースIDに紐付くコース進捗を取得します（※体験ユーザーは使用しない）
     * @summary 学習者進度・コース進捗
     * @param {CourseId} courseId コースID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProgressApi
     */
    public showUserProgress(courseId: CourseId, options?: any) {
        return UserProgressApiFp(this.configuration).showUserProgress(courseId, options)(this.axios, this.basePath);
    }

}


